import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingPlan.BulkUpdatePricingPlanClass.IRequest;
type Headers = Api.Core.ProductPricingPlan.BulkUpdatePricingPlanClass.IHeaders;
type Response = Api.Core.ProductPricingPlan.BulkUpdatePricingPlanClass.IResponse;
const url = '/api/ProductManagement/ProductPricingPlan/BulkUpdatePricingPlanClass';
export async function productPricingPlanBulkUpdatePricingPlanClassApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    body,
    url,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
